// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UWNY","col":"styles_col__15kG1","actions":"styles_actions__6d7BS","conflict":"styles_conflict__1a7ly"};